import React from "react";
import PropTypes from "prop-types";

/**
 * InfoList - renders a semantic unordered list for info sections.
 * @param {string[]} items - Array of strings or React nodes to display as list items.
 * @param {string} className - Optional className for the <ul> element.
 */
const InfoList = ({ items, className = "" }) => (
  <ul
    className={`info-list custom-pointer-list margin-left-8 ${className}`.trim()}
  >
    {items.map((item, idx) => (
      <li className="info-list-item" key={idx}>
        {item}
      </li>
    ))}
  </ul>
);

InfoList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.node).isRequired,
  className: PropTypes.string,
};

export default InfoList;
